export default "__VITE_ASSET__BcmoWWKd__"